import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";
import { NavigationMenuLink } from "~/components/ui/navigation-menu";
import { useURL } from "~/contexts";

import explore from "../../images/explore.png";
import shopSale from "../../images/shopSale.png";
import Image from "../ui/image";
import { P } from "../ui/text";

export const MobileMenu = ({ key }: { key: string | undefined }) => {
  const url = useURL();
  return (
    <div
      className="my-4 flex w-full flex-col justify-center gap-4 text-left"
      key={key}
    >
      <Accordion type="single" collapsible>
        <AccordionItem value="shop">
          <AccordionTrigger>Shop</AccordionTrigger>
          <AccordionContent>
            <ul className="text-accent-12">
              <NavigationMenuLink
                to={url("/shop")}
                className="block pb-7 font-normal"
              >
                View all
              </NavigationMenuLink>
              <li>
                <P className="font-bold leading-none">New Arrivals</P>
                <NavigationMenuLink
                  to={url("/shop/new-arrivals")}
                  className="block pb-[24px] pt-[28px] font-normal"
                >
                  New Arrivals
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/accessories/bags")}
                  className="block pb-[24px] font-normal"
                >
                  Bags
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[24px]"
                >
                  Tops
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/swimwear")}
                  className="block pb-[28px] font-normal"
                >
                  Swimwear
                </NavigationMenuLink>
                <P className="font-bold leading-none">Best Sellers</P>
                <NavigationMenuLink
                  to={url("/shop/edits/bestsellers")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  Best Sellers
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Leggings</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
                <NavigationMenuLink
                  prefetch="intent"
                  to={url(
                    "/shop/bottoms/leggings?refine=c_block-name%3DSuper+Soft",
                  )}
                  className="block pt-[24px] font-normal"
                >
                  Soft leggings
                </NavigationMenuLink>{" "}
                <NavigationMenuLink
                  prefetch="intent"
                  to={url("/shop/bottoms/leggings/2")}
                  className="block pt-[24px] font-normal"
                >
                  Cropped
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings/leggings-with-pockets")}
                  className="block pb-[28px] pt-[24px] font-normal"
                >
                  Power UltraSculpt High-Waisted Gym Leggings with pockets
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Bottoms</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Tops</P>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  Tops
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[28px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={explore}
                    alt="explore"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[24px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={shopSale}
                    alt="shop-sale"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
              </li>
            </ul>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="new-arrivals">
          <AccordionTrigger>New Arrivals</AccordionTrigger>
          <AccordionContent>
            <ul className="text-accent-12">
              <NavigationMenuLink
                to={url("/shop")}
                className="block pb-7 font-normal"
              >
                View all
              </NavigationMenuLink>
              <li>
                <P className="font-bold leading-none">New Arrivals</P>
                <NavigationMenuLink
                  to={url("/shop/new-arrivals")}
                  className="block pb-[24px] pt-[28px] font-normal"
                >
                  New Arrivals
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/accessories/bags")}
                  className="block pb-[24px] font-normal"
                >
                  Bags
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[24px]"
                >
                  Tops
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/swimwear")}
                  className="block pb-[28px] font-normal"
                >
                  Swimwear
                </NavigationMenuLink>
                <P className="font-bold leading-none">Best Sellers</P>
                <NavigationMenuLink
                  to={url("/shop/edits/bestsellers")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  Best Sellers
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Leggings</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
                <NavigationMenuLink
                  prefetch="intent"
                  to={url(
                    "/shop/bottoms/leggings?refine=c_block-name%3DSuper+Soft",
                  )}
                  className="block pt-[24px] font-normal"
                >
                  Soft leggings
                </NavigationMenuLink>{" "}
                <NavigationMenuLink
                  prefetch="intent"
                  to={url("/shop/bottoms/leggings/2")}
                  className="block pt-[24px] font-normal"
                >
                  Cropped
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings/leggings-with-pockets")}
                  className="block pb-[28px] pt-[24px] font-normal"
                >
                  Power UltraSculpt High-Waisted Gym Leggings with pockets
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Bottoms</P>
                <NavigationMenuLink
                  to={url("/shop/bottoms/leggings")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  All leggings
                </NavigationMenuLink>
              </li>
              <li>
                <P className="font-bold leading-none">Tops</P>
                <NavigationMenuLink
                  to={url("/shop/tops")}
                  className="block pb-[28px] pt-[28px] font-normal"
                >
                  Tops
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[28px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={explore}
                    alt="explore"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
                <NavigationMenuLink
                  to={url("/shop")}
                  className="mb-[24px] block h-[228px] w-[221px]"
                >
                  <Image
                    src={shopSale}
                    alt="shop-sale"
                    className="object-fit rounded-md"
                  />
                </NavigationMenuLink>
              </li>
            </ul>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="accessories">
          <AccordionTrigger>Accessories</AccordionTrigger>
          <AccordionContent>
            <NavigationMenuLink
              to={url("/shop/accessories")}
              className="rounded-full text-base font-normal hover:no-underline"
            >
              View all
            </NavigationMenuLink>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="blog">
          <AccordionTrigger>Blog</AccordionTrigger>
          <AccordionContent>
            <NavigationMenuLink
              to={url("/pages")}
              className="rounded-full text-base font-normal hover:no-underline"
            >
              View all
            </NavigationMenuLink>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="story">
          <AccordionTrigger>Story</AccordionTrigger>
          <AccordionContent>
            <NavigationMenuLink
              to={url("/pages/our-story")}
              className="rounded-full text-base font-normal hover:no-underline"
            >
              View all
            </NavigationMenuLink>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="summer-sale">
          <AccordionTrigger>Summer Sale</AccordionTrigger>
          <AccordionContent>
            <NavigationMenuLink
              to={url("/pages/summer-sale")}
              className="rounded-full text-base font-normal hover:no-underline"
            >
              View all
            </NavigationMenuLink>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="sales-page">
          <AccordionTrigger>Sales Page</AccordionTrigger>
          <AccordionContent>
            <NavigationMenuLink
              to={url("/pages/sales-page")}
              className="rounded-full text-base font-normal hover:no-underline"
            >
              View all
            </NavigationMenuLink>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
